import { render, staticRenderFns } from "./Studies.vue?vue&type=template&id=21081f4f&"
import script from "./Studies.vue?vue&type=script&lang=js&"
export * from "./Studies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21081f4f')) {
      api.createRecord('21081f4f', component.options)
    } else {
      api.reload('21081f4f', component.options)
    }
    module.hot.accept("./Studies.vue?vue&type=template&id=21081f4f&", function () {
      api.rerender('21081f4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/Studies.vue"
export default component.exports